export default __webpack_public_path__ + "static/media/gallery_01.56ca75a4.jpg";